customElements.get("vanilla-slider-fade") || customElements.define("vanilla-slider-fade", class extends HTMLElement {
  constructor() {
    super(), this.slider = this.querySelector("[data-slider]"), this.slides = this.querySelectorAll("[data-slide]"), 
    this.autoplay = Number(1e3 * this.dataset.autoplay || 0), this.currentIndex = 0, 
    this.interval = null;
  }
  connectedCallback() {
    !this.slider || this.slides.length <= 1 || (this.init(), this.addEventListeners());
  }
  init() {
    this.slides.forEach((t, s) => {
      t.classList.toggle("is-active", 0 === s);
    }), this.autoplay && this.startAutoplay();
  }
  startAutoplay() {
    this.autoplay && (this.stopAutoplay(), this.interval = setInterval(() => {
      const t = (this.currentIndex + 1) % this.slides.length;
      this.goTo(t);
    }, this.autoplay));
  }
  stopAutoplay() {
    clearInterval(this.interval);
  }
  goTo(t) {
    t === this.currentIndex || t < 0 || t >= this.slides.length || (this.slides[this.currentIndex].classList.remove("is-active"), 
    this.slides[t].classList.add("is-active"), this.currentIndex = t);
  }
  addEventListeners() {
    this.autoplay && (this.addEventListener("mouseenter", this.stopAutoplay.bind(this)), 
    this.addEventListener("mouseleave", this.startAutoplay.bind(this)), this.addEventListener("focusin", this.stopAutoplay.bind(this)), 
    this.addEventListener("focusout", this.startAutoplay.bind(this)));
  }
});